import React__default from 'react';
import CheckBoxFilter from '../CheckBoxFilter/index.js';
import SelectFilter from '../SelectFilter/index.js';
import SliderFilter from '../SliderFilter/index.js';

var Filter = function (_a) {
    var filter = _a.filter, onChange = _a.onChange, mobile = _a.mobile;
    switch (filter.type) {
        case "slider":
            return React__default.createElement(SliderFilter, { filter: filter, onChange: onChange, mobile: mobile });
        case "checkbox":
            return React__default.createElement(CheckBoxFilter, { filter: filter, onChange: onChange, mobile: mobile });
        case "select":
            return React__default.createElement(SelectFilter, { filter: filter, onChange: onChange, mobile: mobile });
        case "text":
            return React__default.createElement(React__default.Fragment, null);
    }
};

export { Filter as default };
